import React from 'react';
import './Faq.scss';

const faqData = [
  {
    question: '1. How to restore my photos. ',
    answer: '（1）Open the "Photos" app\n' +
        '（2）Scroll down to the "Recently Deleted" button\n' +
        '（3）On the upper right corner, tap the"Select" button\n' +
        '（4）Select the photos you want to recover\n' +
        '（5）On the left-down corner, tap the"recover" button\n' +
        '（6）Then tap the "recover photo" button'
  },
  {
    question: '2. Why didn\'t space on my device free up after Smart Cleaning?',
    answer: 'After you perform Smart Cleaning, all deleted photos and videos will be moved to the Recently Deleted album on your device. To free up space, go to Photos>Recently Deleted select the files you want to remove and tap Delete.\n' +
        '\n' +
        'Here are the detailed steps for operation, and please note that after deleting from the Recently Deleted album, files cannot be restored.\n' +
        '\n' +
        '（1）Open the "Photos" app\n' +
        '（2）Scroll down to the "Recently Deleted" button\n' +
        '（3）On the upper right corner, tap the"Select" button\n' +
        '（4）On the left-down corner, tap the"Delete All" button\n' +
        '（5）Then tap the "Delete From All Devices" button'
  }
];

const Faq = () => {
  return (
    // <div className="faq-container">
    <div >
      <div className="faq-list">
        {faqData.map((item, index) => (
          <div key={index} className="faq-item">
            <h1 className="faq-question">{item.question}</h1>
            <p className="faq-answer">{item.answer}</p>
            {index < faqData.length - 1 && <hr className="faq-divider" />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
